import {SettingOutlined, UserOutlined} from '@ant-design/icons';
import {Col, Layout, Menu, Row} from 'antd';
import React from 'react';
import styles from './Admin.module.less';
import {Link, Route, Routes} from "react-router-dom";
import UserList from "./UserList";

const {Header, Content, Footer, Sider} = Layout;

interface AdminProps {
  temp: string
}

function Admin(props: AdminProps) {
  const {temp} = props;
  return (
    <div className={styles.root}>
      <Layout style={{minHeight: 'calc(100vh - 40px)', margin: '0 auto'}}>
        <Sider
          theme="light"
          breakpoint="lg"
          collapsedWidth="0"
        >
          <Menu
            theme="light"
            mode="inline"
            items={[
              {
                key: 'user',
                icon: <UserOutlined/>,
                label: <Link to="/admin/user">用户管理</Link>,
              },
              {
                key: 'config',
                icon: <SettingOutlined/>,
                label: <Link to="/admin/config">系统设置</Link>,
              },
            ]}
          />
        </Sider>
        <Layout className={styles.layout}>
          <Content style={{margin: '16px 16px 0'}}>
            <div className={styles.main}>
              <Routes>
                <Route path="/" element={<div>Admin 首页</div>}/>
                <Route path="user" element={<UserList temp={"1"}/>}/>
                <Route path="config" element={<div>
                  系统设置 <br/>
                  邮件设置 <br/>
                  SNL更新配置 <br/>
                  SNL映射配置 <br/>
                  缓存配置，手动清缓存 <br/>
                  BC更新
                </div>}/>
              </Routes>
            </div>
          </Content>
          <Footer style={{textAlign: 'center'}}>图智</Footer>
        </Layout>
      </Layout>
    </div>
  )
}

export default Admin;
